require('./angulartics-google-tag-manager');
module.exports = 'angulartics.google.tagmanager';



//////////////////
// WEBPACK FOOTER
// ../~/angulartics-google-tag-manager/lib/index.js
// module id = 111
// module chunks = 0